import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SchoolDirectory } from '../models/school.directory';
import { User } from '../models/user';
import { AppConfigService } from './app.config.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // apiUrl = 'https://localhost:32771/profileapi/api';
  api = this.configService.sytemConfiguration.apiUrl;

  constructor(private http: HttpClient, private configService: AppConfigService) { }

  getProfileById(id: number): Observable<User> {
    return this.http.get<User>(`${this.api}/user/${id}/profile`);
  }

  getDirectory(): Observable<SchoolDirectory> {
    return this.http.get<SchoolDirectory>(this.api + '/school/directory');
  }

  getSectionByUserId<T>(id: number, section: string): Observable<T[]> {
    return this.http.get<T[]>(`${this.api}/user/${id}/${section}`);
  }

}
